import { AccountBenefitsModalManager, PhoneVerificationManager } from 'components/account';
import { ConsentManager } from 'components/consent';
import { GeniusFastCheckoutManager, GeniusTrialModalManager } from 'components/genius';

// TODO: move from layout into dedicated folders
import BannerToastsManager from '../BannerToastsManager/BannerToastsManager';
import NewsletterSubscribeModalManager from '../NewsletterSubscribeModalManager/NewsletterSubscribeModalManager';

const Managers = () => {
  return (
    <>
      <BannerToastsManager />
      <ConsentManager />
      <NewsletterSubscribeModalManager />
      <GeniusFastCheckoutManager />
      <PhoneVerificationManager />
      <GeniusTrialModalManager />
      <AccountBenefitsModalManager />
      {/* For now, this is only required on homepage and therefore imported in HomepageTemplate */}
      {/* <OrderFeedbackReminderModalManager /> */}
    </>
  );
};

export default Managers;
